const findIndex = (values: string[], limit: number): number => {
  let number = 0;
  let index = -1;

  for (let iterator = 0; iterator < values.length; iterator++) {
    if (number >= limit) {
      break;
    }
    const space = iterator === 0 ? 0 : 1;
    const length = number + values[iterator].length + space; // iterator is for spaces between words
    if (length <= limit) {
      index = iterator;
      number = length;
    } else {
      break;
    }
  }

  return index;
};

const getCurrentDescription = (value: string, isLong = false, limit = 300): string => {
  if (value.length <= limit) {
    return value;
  }
  if (!isLong) {
    const valuesArray = value.split(" ");
    const index = findIndex(valuesArray, limit);

    if (index === -1) {
      return value;
    }

    const newDescription = `${valuesArray.slice(0, index + 1).join(" ")} ...`;
    return newDescription;
  }

  return value;
};

export default getCurrentDescription;
